module.exports = __webpack_public_path__ + "packs/media/images/box_2a-350bb5bf27cbe0ff0166cb748abf14a8.png";